import { loadStripe } from '@stripe/stripe-js';

/**
 * Shared Stripe.js promise — reuses a single `loadStripe` call across
 * all components that render the Stripe Embedded Checkout.
 */
export const stripePromise = process.env.STRIPE_PUBLISHABLE_KEY ? loadStripe(process.env.STRIPE_PUBLISHABLE_KEY) : null;
